
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/claims-guide",
      function () {
        return require("private-next-pages/claims-guide.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/claims-guide"])
      });
    }
  